import { REGION } from '../../data/idConstants';

export const handleFormInputChangeUtil = (data, formFields) => {
  const { value, name, error } = data;
  const updatedFields = formFields.map((field) => {
    if (field.name === name) {
      return { ...field, value, error };
    }

    if (field.type === 'COMBINE' && field.attributes) {
      const updatedAttributes = field.attributes.map((attr) => {
        if (attr.name === name) {
          return { ...attr, value, error };
        }
        return attr;
      });
      return { ...field, attributes: updatedAttributes };
    }

    return field;
  });
  return updatedFields;
};

export const handleFormBlurUtil = (data, formFields) => {
  const { name, error } = data;
  const updatedFields = formFields.map((field) => {
    if (field.name === name) {
      return { ...field, error };
    }

    if (field.type === 'COMBINE' && field.attributes) {
      const updatedAttributes = field.attributes.map((attr) => {
        if (attr.name === name) {
          return { ...attr, error };
        }
        return attr;
      });
      return { ...field, attributes: updatedAttributes };
    }

    return field;
  });
  return updatedFields;
};

export const handleGetInTouchSubmitUtil = async ({
  formFields,
  recaptchaToken,
  isDpnAccepted,
  accessToken,
  dispatch,
  postUserQuery,
  onSuccess
}) => {
  const formData = {};
  const currentRegion = process.env.REACT_APP_REGION;

  formFields.forEach((field) => {
    formData[field.name] = field.value || '';
    if (field.type === 'COMBINE' && field.attributes) {
      field.attributes.forEach((attr) => {
        formData[attr.name] = attr.value || '';
      });
    } else {
      formData[field.name] = field.value || '';
    }
  });

  const isdCode = formData['isdCode']?.value || formData['isdCode'] || '';
  const phoneNumber = formData['phoneNumber'] || '';
  const contactNo = isdCode && phoneNumber ? `${isdCode} ${phoneNumber}` : '';

  const payload = {
    name: formData['name'],
    company: formData['organization'],
    emailId: formData['email'],
    contactNo: contactNo,
    description: formData['description'],
    reCaptchaResponse: recaptchaToken,
    userConsent: isDpnAccepted,
    detailsFrom: 'USP',
    region: currentRegion
  };
  payload['msCustomerId'] = accessToken ? 'Yes' : 'No';

  const response = await dispatch(postUserQuery(payload));
  if (response?.success && onSuccess) {
    onSuccess(formFields);
  }
  return response;
};

export const clearFormUtil = ({
  getInTouchDynamicFormFields,
  setFormFields,
  setRecaptchaToken,
  setIsReCaptchaVerified,
  setIsDpnAccepted,
  setIsGetInTouchSubmitEnabled,
  recaptchaRef,
  currentFormFields,
  countryList = []
}) => {
  const clearedFields = getInTouchDynamicFormFields?.map((field) => {
    if (field.type === 'COMBINE' && field.attributes) {
      const currentField = currentFormFields?.find(
        (currentFieldItem) => currentFieldItem.name === field.name
      );
      if (currentField) {
        const updatedAttributes = field.attributes.map((attr) => {
          const currentAttr = currentField.attributes?.find(
            (item) => item.name === attr.name
          );
          if (attr.name === 'isdCode' && currentAttr?.options) {
            const { isdCode, countryCode } = getDefaultIsdCodeByRegion(countryList);
            const defaultOption = findDefaultOptionInCountryList(
              currentAttr.options,
              isdCode,
              countryCode
            );

            return {
              ...attr,
              options: currentAttr.options,
              value: defaultOption || ''
            };
          }
          return attr;
        });
        return { ...field, attributes: updatedAttributes };
      }
    }
    return field;
  });

  setFormFields(clearedFields);
  setRecaptchaToken('');
  setIsReCaptchaVerified(false);
  setIsDpnAccepted(false);
  setIsGetInTouchSubmitEnabled(false);

  recaptchaRef?.current?.reset();
};

const removeDuplicateCountries = (countryList) => {
  return countryList.filter(
    (country, index, self) =>
      index ===
      self.findIndex(
        (item) =>
          item.countryCode === country.countryCode &&
          item.isdCode === country.isdCode
      )
  );
};

const groupCountriesByIsdCode = (countries) => {
  return countries.reduce((acc, country) => {
    const isdCode = country.isdCode;
    if (!acc[isdCode]) {
      acc[isdCode] = [];
    }
    acc[isdCode].push(country);
    return acc;
  }, {});
};

const createCountryOption = (isdCode, countries) => {
  if (countries.length === 1) {
    const country = countries[0];
    return {
      id: country.countryCode,
      label: `${country.isdCode} (${country.countryName})`,
      value: country.isdCode,
      displayValue: country.isdCode
    };
  }

  const sortedCountries = countries.sort((a, b) =>
    b.countryName.localeCompare(a.countryName)
  );
  const countryNames = sortedCountries.map((item) => item.countryName).join('/');
  const primaryCountry = sortedCountries[0];
  return {
    id: primaryCountry.countryCode,
    label: `${isdCode} (${countryNames})`,
    value: isdCode,
    displayValue: isdCode
  };
};

export const createCountryOptions = (countryList) => {
  const uniqueCountries = removeDuplicateCountries(countryList);
  const groupedByIsdCode = groupCountriesByIsdCode(uniqueCountries);

  const options = Object.keys(groupedByIsdCode).map((isdCode) =>
    createCountryOption(isdCode, groupedByIsdCode[isdCode])
  );

  return options;
};

export const getDefaultIsdCodeByRegion = (countryList = []) => {
  const currentRegion = process.env.REACT_APP_REGION;

  const regionCountryMap = {
    [REGION.IN.CODE]: 'IN',
    [REGION.EU.CODE]: 'DE',
    [REGION.NA.CODE]: 'US'
  };

  const fallbackMap = {
    [REGION.IN.CODE]: { isdCode: '+91', countryCode: 'IN' },
    [REGION.EU.CODE]: { isdCode: '+49', countryCode: 'DE' },
    [REGION.NA.CODE]: { isdCode: '+1', countryCode: 'US' }
  };

  const targetCountryCode = regionCountryMap[currentRegion] || 'IN';
  const country = countryList.find((item) => item.countryCode === targetCountryCode);

  return country
    ? { isdCode: country.isdCode, countryCode: country.countryCode }
    : fallbackMap[currentRegion] || fallbackMap[REGION.IN.CODE];
};

export const findDefaultOptionInCountryList = (
  countryOptions,
  defaultIsdCode,
  defaultCountryCode
) => {
  return (
    countryOptions.find(
      (option) => option.value === defaultIsdCode && option.id === defaultCountryCode
    ) ||
    countryOptions.find((option) => option.value === defaultIsdCode) ||
    null
  );
};

export const updateFormFieldsWithCountryOptions = (
  formFields,
  countryOptions,
  countryList = [],
  preSelectDefault = true
) => {
  return formFields.map((field) => {
    if (field.type === 'COMBINE' && field.attributes) {
      const updatedAttributes = field.attributes.map((attr) => {
        if (attr.name === 'isdCode') {
          let updatedAttr = { ...attr, options: countryOptions };

          if (preSelectDefault && !attr.value && countryOptions.length > 0) {
            const { isdCode, countryCode } = getDefaultIsdCodeByRegion(countryList);
            const defaultOption = findDefaultOptionInCountryList(
              countryOptions,
              isdCode,
              countryCode
            );

            if (defaultOption) {
              updatedAttr.value = defaultOption;
            }
          }

          return updatedAttr;
        }
        return attr;
      });
      return { ...field, attributes: updatedAttributes };
    }
    return field;
  });
};

export const updatePhoneValidation = (
  countryCode,
  setFormFields,
  contactValidationList
) => {
  const contactValidation =
    contactValidationList[countryCode]?.contactNo ??
    contactValidationList.default.contactNo;

  setFormFields((prevFields) =>
    prevFields.map((field) => {
      if (field.type === 'COMBINE') {
        const updatedAttributes = field.attributes?.map((attr) => {
          if (attr.name === 'phoneNumber') {
            return {
              ...attr,
              value: '',
              error: '',
              validation: {
                ...attr.validation,
                rule: {
                  ...attr.validation.rule,
                  regex: {
                    pattern: contactValidation.pattern
                  },
                  length: {
                    max: contactValidation.maxCharLimit
                  }
                }
              }
            };
          }
          return attr;
        });
        return { ...field, attributes: updatedAttributes };
      }
      return field;
    })
  );
};
